import React from 'react';

import useWebSocket from 'react-use-websocket';

import WSContext, { WebSocketGroup, type Subscriptions } from 'src/features/visitor/context/WSContext';
import { WebSocketEvent } from 'src/features/visitor/types';
import { WS_ENDPOINT } from 'src/config';
import AuthContext from 'src/features/auth/context/AuthContext';

export function WSProvider({ children }: { children: React.ReactNode }) {
    const { user }= React.useContext(AuthContext);
    const { lastJsonMessage, sendJsonMessage } = useWebSocket<{ group?: WebSocketGroup }>(WS_ENDPOINT, {}, !!user);
    const subscriptions = React.useRef<Subscriptions>({});

    const subscribe = React.useCallback((group: WebSocketGroup, callback: (data: WebSocketEvent) => void) => {
        const subs = subscriptions.current[group];

        if (!subs || !subs.length) {
            sendJsonMessage({
                action: 'subscribe',
                group,
            });
            subscriptions.current[group] = [];
        }

        subscriptions.current[group].push(callback);
    }, [sendJsonMessage]);

    const unsubscribe = React.useCallback((group: WebSocketGroup, callback: (data: WebSocketEvent) => void) => {
        const subs = subscriptions.current[group];
        if (!subs) return;
        subscriptions.current[group].splice(
            subscriptions.current[group].findIndex((i) => i === callback),
            1,
        );
        if (!subscriptions.current[group].length) {
            sendJsonMessage({
                action: 'unsubscribe',
                group,
            });
        }
    }, [sendJsonMessage]);

    React.useEffect(() => {
        const group = lastJsonMessage?.group;
        if (group && subscriptions.current[group]) {
            subscriptions.current[group].map((callback) => {
                callback(lastJsonMessage);
            });
        }
    }, [lastJsonMessage]);

    return (
        <WSContext.Provider
            value={{
                subscribe,
                unsubscribe,
            }}
        >
            {children}
        </WSContext.Provider>
    );
}
